export const saRolesProvType = {
    'CloudSql' : ['servicenetworking.networksAdmin', 'iam.serviceAccountTokenCreator'],
    'Patch':  ['servicenetworking.networksAdmin', 'iam.serviceAccountTokenCreator']
 };
